import { render, staticRenderFns } from "./DatavizGauge.vue?vue&type=template&id=acaa3f54&"
import script from "./DatavizGauge.vue?vue&type=script&lang=js&"
export * from "./DatavizGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports